import React from 'react';
import Alerts from 'screens/Home/components/Alerts';
import {
  AlertsScreenContainer,
  Content,
  Container,
} from './styles';

const AlertsScreen = ({mobile, open}) => {

  return (
    <AlertsScreenContainer mobile={mobile} open={open}>
      <Content>
        <Container>
          <Alerts mobile/>
        </Container>
      </Content>
    </AlertsScreenContainer>
  )
}

export default AlertsScreen;
